export const locales = ['en', 'es', 'fr', 'de', 'ro', 'pt', 'zh', 'hi', 'ar', 'bn', 'it', 'ru'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

// The [locale] route param used for unprefixed default-locale URLs - the
// rewrite target segment in next.config.ts (which must keep the literal
// '/locale/...' destinations: next.config is transpiled standalone and cannot
// import this). Consumed by proxy.ts, the [locale] layout's
// generateStaticParams, and the CDN purge relay's revalidatePath targets.
export const LOCALE_SENTINEL = 'locale';

// Text direction per locale (BCP 47 lang values are the locale codes
// themselves). Used for <html lang/dir>: the pre-paint script in
// app/layout.tsx and the LocaleHtmlAttributes effect in the [locale] layout
// must agree with this map.
export const rtlLocales: readonly Locale[] = ['ar'];

// og:locale wants language_TERRITORY; the territory half is a per-locale
// decision (en -> en_US, zh -> zh_CN), not derivable from the code. Keyed by
// Locale so adding a language fails compilation until it gets a mapping.
export const ogLocales: Record<Locale, string> = {
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  de: 'de_DE',
  ro: 'ro_RO',
  pt: 'pt_PT',
  zh: 'zh_CN',
  hi: 'hi_IN',
  ar: 'ar_AR',
  bn: 'bn_BD',
  it: 'it_IT',
  ru: 'ru_RU',
};

export function localeDirection(locale: Locale): 'ltr' | 'rtl' {
  return rtlLocales.includes(locale) ? 'rtl' : 'ltr';
}

export const localeNames: Record<Locale, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  ro: 'Română',
  pt: 'Português',
  zh: '中文',
  hi: 'हिन्दी',
  ar: 'العربية',
  bn: 'বাংলা',
  it: 'Italiano',
  ru: 'Русский',
};
